module.exports = require('./helpers/bundle-url').getBundleURL('dj12v') + "okx.11891fb5.svg";